import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {getCurrentGroups} from "./lookWizardFunctions";


const LookWizardContentDescription = (props) => {

  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues} = props;

  const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);

  if (wizardActiveStep === -1) {
    return wizardActiveItem.description
  }
  if (wizardActiveStep > -1 && currentGroups.length === 1) {
    return currentGroups[0].description
  }
  if (wizardActiveStep > -1 && !currentGroups.length) {
    return <FormattedMessage id="wizard.completed.description" values={{wizardName: wizardActiveItem.name}}/>
  }
  if (wizardActiveStep === 0 && currentGroups.length > 1 && wizardActiveItem.startDescription) {
    return wizardActiveItem.startDescription
  }
  return null
};

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues} = store.wizardState;
  return {
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
  };
};

export default connect(mapStateToProps)(LookWizardContentDescription)
